import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import { withRouter, Link } from 'react-router-dom';

import niaLogo from '../../static/img/logo.webp';
import DesktopNav from './DesktopNav';
import MobileNav from './MobileNav';
import NavMenus from './NavMenus';


const styles = theme => ({
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
  },
  flowGrow: {
    flexGrow: 1,
  },
  logo: {
    marginLeft: 10,
    height: 40,
    marginTop: '4px',
  },
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
    // height: 64,
  },
  googleTranslateElement: {
    [theme.breakpoints.down('md')]: {
      visibility: 'hidden',
    },
  },
  sectionMobile: {
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  externalLink: {
    textDecoration: 'none',
    '&:focus': {
      outline: 'none',
    },
    color: theme.palette.text.primary,
  },
  navIcon: {
    marginLeft: 4,
    height: 24,
    width: 24,
  },
  navIconCustom: {
    height: 28,
    width: 28,
  },
});

// UA-70258310-7
/* eslint-disable no-undef */
const googleTranslateElementInit = () => {
  google.translate.TranslateElement({
    pageLanguage: 'en',
    layout: google.translate.TranslateElement.InlineLayout.SIMPLE,
    autoDisplay: false,
    gaTrack: true,
    gaId: 'UA-70258310-7',
  }, 'google_translate_element');
};

class NavBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl0: null,
      anchorEl: null,
      anchorEl2: null,
      anchorEl3: null,
      // anchorEl4: null,
      anchorEl5: null,
      anchorEl6: null,
      mobileMoreAnchorEl: null,
    };

    this.handleShopMenu = this.handleShopMenu.bind(this);
    this.handleUserMenu = this.handleUserMenu.bind(this);
    this.handleClassesMenu = this.handleClassesMenu.bind(this);
    this.handleTrainingsMenu = this.handleTrainingsMenu.bind(this);
    this.handleEventsMenu = this.handleEventsMenu.bind(this);
    // this.handleMembershipMenu = this.handleMembershipMenu.bind(this);
    this.handleShopClose = this.handleShopClose.bind(this);
    this.handleUserClose = this.handleUserClose.bind(this);
    this.handleClassesClose = this.handleClassesClose.bind(this);
    this.handleTrainingsClose = this.handleTrainingsClose.bind(this);
    this.handleEventsClose = this.handleEventsClose.bind(this);
    // this.handleMembershipClose = this.handleMembershipClose.bind(this);
    this.handleMobileMenuOpen = this.handleMobileMenuOpen.bind(this);
    this.handleMobileMenuClose = this.handleMobileMenuClose.bind(this);
    this.handleAboutMenu = this.handleAboutMenu.bind(this);
    this.handleAboutClose = this.handleAboutClose.bind(this);
  }

  componentDidMount() {
    document.getElementById('google-translate')
    const addScript = document.createElement('script');
    addScript.setAttribute('src', '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit');
    addScript.setAttribute('id', 'google_translate_script2');
    document.body.appendChild(addScript);
    window.googleTranslateElementInit = googleTranslateElementInit;
  }

  componentWillUnmount() {
    const e1 = document.getElementsByClassName('goog-te-menu-frame')[0]
    if (e1) {
      // console.log('killing menu frame')
      e1.parentElement.removeChild(e1);
    }
    const e2 = document.getElementById('goog-gt-tt')
    if (e2) {
      // console.log('killing gt tt')
      e2.parentElement.removeChild(e2);
    }
    const e3 = document.getElementsByClassName('goog-te-spinner-pos')[0]
    if (e3) {
      // console.log('killing spinner')
      e3.parentElement.removeChild(e3);
    }
    const e4 = document.getElementById('google_translate_script2')
    if (e4) {
      // console.log('killing script')
      e4.parentElement.removeChild(e4);
    }
  }

  handleAboutMenu(event) {
    this.setState({ anchorEl0: event.currentTarget });
  }

  handleAboutClose() {
    this.setState({ anchorEl0: null });
  }

  handleClassesMenu(event) {
    this.setState({ anchorEl: event.currentTarget });
  }

  handleClassesClose() {
    this.setState({ anchorEl: null });
  }

  handleTrainingsMenu(event) {
    this.setState({ anchorEl2: event.currentTarget });
  }

  handleTrainingsClose() {
    this.setState({ anchorEl2: null });
  }

  handleEventsMenu(event) {
    this.setState({ anchorEl3: event.currentTarget });
  }

  handleEventsClose() {
    this.setState({ anchorEl3: null });
  }

  // handleMembershipMenu(event) {
  //   this.setState({ anchorEl4: event.currentTarget });
  // }

  // handleMembershipClose() {
  //   this.setState({ anchorEl4: null });
  // }

  handleShopMenu(event) {
    this.setState({ anchorEl5: event.currentTarget });
  }

  handleShopClose() {
    this.setState({ anchorEl5: null });
  }

  handleUserMenu(event) {
    this.setState({ anchorEl6: event.currentTarget });
  }

  handleUserClose() {
    this.setState({ anchorEl6: null });
  }

  handleMobileMenuOpen(event) {
    this.setState({ mobileMoreAnchorEl: event.currentTarget });
  }

  handleMobileMenuClose() {
    this.setState({ mobileMoreAnchorEl: null });
  }

  render() {
    const {
      classes,
      user,
      elevation,
    } = this.props;
    const {
      anchorEl0,
      anchorEl,
      anchorEl2,
      anchorEl3,
      // anchorEl4,
      anchorEl5,
      anchorEl6,
      mobileMoreAnchorEl,
    } = this.state;
    const aboutMenuOpen = Boolean(anchorEl0);
    const classesMenuOpen = Boolean(anchorEl);
    const trainingsMenuOpen = Boolean(anchorEl2);
    const eventsMenuOpen = Boolean(anchorEl3);
    // const membershipMenuOpen = Boolean(anchorEl4);
    const shopMenuOpen = Boolean(anchorEl5);
    const userMenuOpen = Boolean(anchorEl6);
    const mobileMenuOpen = Boolean(mobileMoreAnchorEl);

    return (
      <React.Fragment>
        <AppBar className={classes.appBar} elevation={elevation} position="fixed">
          <Toolbar>
            <div className={classes.flowGrow}>
              <Link to="/">
                <img src={niaLogo} alt="Nia" className={classes.logo} />
              </Link>
            </div>

            {/* Google Translate div gets filled by script */}
            <div className={classes.googleTranslateElement} id="google_translate_element" />

            {/* DESKTOP NAV */}
            <DesktopNav
              classes={classes}
              handleAboutMenu={this.handleAboutMenu}
              handleClassesMenu={this.handleClassesMenu}
              handleTrainingsMenu={this.handleTrainingsMenu}
              handleEventsMenu={this.handleEventsMenu}
              // handleMembershipMenu={this.handleMembershipMenu}
              handleShopMenu={this.handleShopMenu}
              userMenuOpen={userMenuOpen}
              handleUserMenu={this.handleUserMenu}
              user={user}
            />

            {/* MOBILE NAV */}
            <MobileNav
              classes={classes}
              handleMobileMenuOpen={this.handleMobileMenuOpen}
            />

          </Toolbar>
        </AppBar>

        {/* Nav Menus  */}
        <NavMenus
          classes={classes}
          user={user}
          anchorEl0={anchorEl0}
          anchorEl6={anchorEl6}
          anchorEl5={anchorEl5}
          // anchorEl4={anchorEl4}
          anchorEl3={anchorEl3}
          anchorEl2={anchorEl2}
          anchorEl={anchorEl}
          mobileMoreAnchorEl={mobileMoreAnchorEl}
          aboutMenuOpen={aboutMenuOpen}
          handleAboutMenu={this.handleAboutMenu}
          handleAboutClose={this.handleAboutClose}
          shopMenuOpen={shopMenuOpen}
          handleShopMenu={this.handleShopMenu}
          handleShopClose={this.handleShopClose}
          trainingsMenuOpen={trainingsMenuOpen}
          handleTrainingsMenu={this.handleTrainingsMenu}
          handleTrainingsClose={this.handleTrainingsClose}
          eventsMenuOpen={eventsMenuOpen}
          handleEventsMenu={this.handleEventsMenu}
          handleEventsClose={this.handleEventsClose}
          // membershipMenuOpen={membershipMenuOpen}
          // handleMembershipMenu={this.handleMembershipMenu}
          // handleMembershipClose={this.handleMembershipClose}
          classesMenuOpen={classesMenuOpen}
          handleClassesMenu={this.handleClassesMenu}
          handleClassesClose={this.handleClassesClose}
          userMenuOpen={userMenuOpen}
          handleUserMenu={this.handleUserMenu}
          handleUserClose={this.handleUserClose}
          mobileMenuOpen={mobileMenuOpen}
          handleMobileMenuClose={this.handleMobileMenuClose}
        />

      </React.Fragment>
    );
  }
}

NavBar.propTypes = {
  classes: PropTypes.object.isRequired,
  user: PropTypes.object,
  elevation: PropTypes.number,
};

const mapStateToProps = (state) => {
  const { user } = state.loginReducer;
  return {
    user,
  };
};

export default withRouter(withStyles(styles)(connect(mapStateToProps)(NavBar)));
